var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1800_4270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4994 0H8.49979C3.82532 0 0 3.82532 0 8.49979V25.5002C0 30.1734 3.82532 34 8.49979 34H25.4994C30.1738 34 33.9992 30.1734 33.9992 25.5002V8.49979C33.9992 3.82532 30.1738 0 25.4994 0ZM31.1658 25.5002C31.1658 28.6239 28.6248 31.1666 25.4994 31.1666H8.49979C5.3757 31.1666 2.8334 28.6239 2.8334 25.5002V8.49979C2.8334 5.37529 5.3757 2.8334 8.49979 2.8334H25.4994C28.6248 2.8334 31.1658 5.37529 31.1658 8.49979V25.5002Z",
    fill: "#844C0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2089 9.91616C27.3825 9.91616 28.3339 8.96478 28.3339 7.79121C28.3339 6.61763 27.3825 5.66626 26.2089 5.66626C25.0354 5.66626 24.084 6.61763 24.084 7.79121C24.084 8.96478 25.0354 9.91616 26.2089 9.91616Z",
    fill: "#844C0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9998 8.5C12.3045 8.5 8.5 12.3049 8.5 16.9998C8.5 21.6929 12.3045 25.5004 16.9998 25.5004C21.6938 25.5004 25.4996 21.6929 25.4996 16.9998C25.4996 12.3049 21.6938 8.5 16.9998 8.5ZM16.9998 22.667C13.8706 22.667 11.3334 20.1299 11.3334 16.9998C11.3334 13.8697 13.8706 11.3334 16.9998 11.3334C20.129 11.3334 22.6662 13.8697 22.6662 16.9998C22.6662 20.1299 20.129 22.667 16.9998 22.667Z",
    fill: "#844C0D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1800_4270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramicon);
export default __webpack_public_path__ + "static/media/instagramicon.847d7fa292aaf6dfc1b7fd0dfd789bf7.svg";
export { ForwardRef as ReactComponent };